module.exports = __webpack_public_path__ + "img/icon_百万医疗@2x.7ee82c36.png";